import { reactive, getCurrentInstance, computed } from "@vue/composition-api";

export default function useCreateWinnerModal() {
    const vm = getCurrentInstance().proxy;

    const formData = reactive({
        firstName: "",
        lastName: "",
        mobileNo: "",
        address: "",
        isMobileLength: true
    })

    const hasMobile = computed(() => {
        return formData.mobileNo?.length != 10
    })

    const onSubmitModal = () => {
        vm.$emit("onSubmitWinnerModal", formData);
    }

    return {
        formData,
        onSubmitModal,
        hasMobile
    }
}